import React from 'react';
import { useLocalizedStrings } from '../../Localization';
import { BreadcrumbProps, Button, Icon, NumberDisplay, Tooltip } from '@aidkitorg/component-library';
import { useNotifications } from '../../Contexts/NotificationsContext';
import { NotificationsDataTable } from './components/NotificationsDataTable';
import { generateTimestampString } from '../../utils/adminPanel.utils';
import { AdminPanelPage } from '../AdminPanelPage';

export const NotificationsPage = () => {
  const L = useLocalizedStrings()

  const {
    fetchNotificationsOverview, 
    enabledNotifications, 
    notifications,
    notificationsDataTimestamp,

    isNotificationsLoading
  } = useNotifications();

  // Count notifications with SQL errors
  const notificationsWithErrors = notifications.filter(notification => 
    notification.sqlError || (notification.expandableRows?.some(row => row.sqlError))
  ).length;

  const enabledNotificationsCard = <NumberDisplay
    loading={isNotificationsLoading}
    className="sm:max-w-64 min-w-64"
    title={L.admin_panel.notifications.enabled_notifications}
    value={enabledNotifications} 
    iconName="BellIcon" 
    iconColor="blue"
  />

  const sqlErrorsCard = notificationsWithErrors > 0 ? (
    <NumberDisplay
      loading={isNotificationsLoading}
      className="sm:max-w-64 min-w-64"
      title={L.admin_panel.notifications.sql_errors}
      value={notificationsWithErrors} 
      iconName="ExclamationTriangleIcon" 
      iconColor="red"
    />
  ) : null;



  const breadcrumbs: BreadcrumbProps['items'] = [
    {
      label: L.admin_panel.nav.notifications,
    }
  ];
  
  return (
    <AdminPanelPage
      title={L.admin_panel.nav.notifications}
      description={L.admin_panel.notifications.description}
      breadcrumbs={breadcrumbs}
      pageActionButtons={[
        <Tooltip text={L.admin_panel.payments.refresh_data} asChild>
          <Button
            size="sm"
            variant='secondary'
            onClick={() => { fetchNotificationsOverview(true) }}
            icon={<Icon role="decorative" type="solid" name="ArrowPathIcon" />}
            aria-label={L.admin_panel.payments.refresh_data}
          />
        </Tooltip>
      ]}
    >
      <div className="flex flex-col gap-2 sm:gap-4 w-full">
        <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
          {enabledNotificationsCard}
          {sqlErrorsCard}
        </div>
        <div>
          <NotificationsDataTable lastUpdatedTimestamp={notificationsDataTimestamp} />
        </div>
      </div>
    </AdminPanelPage>
  )
}
